import { render, staticRenderFns } from "./DynamicFromNow.vue?vue&type=template&id=d641615e&"
import script from "./DynamicFromNow.vue?vue&type=script&lang=js&"
export * from "./DynamicFromNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports